import { ListItemProps } from "@progress/kendo-react-dropdowns";
import { format, formatDate } from "date-fns";
import { ExemptionVessel, Vessel, VesselAuction } from "interface/vessel";
import React from "react";
import { DATE_FORMAT, DATE_TIME_FORMAT } from "utils/constant";

const VesselRenderItem = (
	li: React.ReactElement<HTMLLIElement>,
	itemProps: ListItemProps
) => {
	const data: Vessel = itemProps.dataItem;
	const item = (
		<div style={{ display: "flex", gap: "40px" }}>
			<div style={{ display: "flex", gap: "6px" }}>

				<span style={{ display: "block" }}>{data.resRnNm}</span>
				<span style={{ display: "block" }}>|</span>
				<span style={{ display: "block" }}>{data.cs}</span>

				{/* <span style={{ display: "block", width: "60px" }}>{data.rn}</span> */}
				<span style={{ display: "block", width: "2px" }}>|</span>
				<span
					style={{ display: "block" }}
				>{`${data.owNm} (${data.fr} - ${data.to})`}</span>
			</div>
		</div>
	);

	return React.cloneElement(li, li.props, item);
};

export const ExemptionVesselRenderItem = (
	li: React.ReactElement<HTMLLIElement>,
	itemProps: ListItemProps
) => {
	const data: ExemptionVessel = itemProps.dataItem;

	const item = (
		<div style={{ display: "flex", gap: "40px" }}>
			<div style={{ display: "flex", gap: "15px" }}>
				<span style={{ display: "block", width: "80px" }}>
					{data.quotaVesselName}
				</span>
				<span style={{ display: "block", width: "80px" }}>
					{data.quotaVesselRegistrationId}
				</span>
				<span style={{ display: "block", width: "150px" }}>
					{data.quotaVesselRadioCallSignal}
				</span>
			</div>
			<div style={{ display: "flex", gap: "20px" }}>
				<span style={{ display: "block" }}>
					{format(new Date(data.validFrom), DATE_TIME_FORMAT)}
				</span>
				<span style={{ display: "block" }}>
					{format(new Date(data.validTo), DATE_TIME_FORMAT)}
				</span>
			</div>
		</div>
	);

	return React.cloneElement(li, li.props, item);
};

export const AuctionObligationVesselsRenderItem = (
	li: React.ReactElement<HTMLLIElement>,
	itemProps: ListItemProps
) => {
	const data: VesselAuction = itemProps.dataItem;
	const item = (
		<div style={{ display: "flex", gap: "40px" }}>
			<div style={{ display: "flex", gap: "15px" }}>
				<span style={{ display: "block", width: "40px" }}>
					{data.fishermanLedgerAccount}
				</span>
				<span style={{ display: "block", width: "60px" }}>
					{data.vesselRegistrationId}
				</span>
				<span style={{ display: "block", width: "45px" }}>
					{data?.vesselRadioCallSignal}
				</span>
				<span style={{ display: "block", width: "150px" }}>
					{data.vesselName}
				</span>
				<span style={{ display: "block", width: "150px" }}>{data.fishermanName?.length > 22 ? `${data.fishermanName.slice(0, 19)}...` : data.fishermanName}</span>
			</div>
			<div style={{ display: "flex", gap: "20px" }}>
				<span style={{ display: "block" }}>{format(new Date(data.validTo), 'dd.MM.yyyy')}</span>
			</div>
		</div>
	);

	return React.cloneElement(li, li.props, item);
};

export default VesselRenderItem;
